import { getProposals } from '../../proposals/proposals.helpers';
import type { Baseline } from '@shared/models/project.model';

/**
 * Reorder {@link IProposal} rows in a version according to `orderedIds`.
 * All existing proposal ids must appear in `orderedIds` (bijection check).
 * Returns the same reference when nothing changes.
 */
export const reorderProposals = (
  version: Baseline,
  orderedIds: string[],
): Baseline => {
  const current = getProposals(version);

  if (current.length !== orderedIds.length) {
    throw new Error(
      `reorderProposals: orderedIds length ${orderedIds.length} does not match proposals length ${current.length}`,
    );
  }

  const byId = new Map(current.map((p) => [p.id, p]));
  const next = orderedIds.map((id) => {
    const p = byId.get(id);
    if (!p) throw new Error(`reorderProposals: unknown proposal id ${id}`);
    return p;
  });

  const unchanged = next.every((p, i) => p === current[i]);
  if (unchanged) return version;

  return { ...version, proposals: next };
};
